import React from 'react'
import cx from 'classnames'

interface FormProps {
  id?: string
  className?: string
  children: React.ReactNode
  onSubmit?: any
}

const Form = ({ id, className, children, onSubmit }: FormProps) => {
  return (
    <form id={id} onSubmit={onSubmit} className={cx('form', className)}>
      {children}
    </form>
  )
}

export default Form
